// Func = limiting Scope for this file

var lastScrollTop = 0;
(function(){
	
		//Call function with browser is resized.
		$(window).resize(function (event) {
			//resizeWindow();
		});
		//resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			//scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}


		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn, #CheckIn-home").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn, #CheckIn-home").data("format") : "mm/dd/yy";		
        $( "#CheckIn, #CheckIn-home" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: '05/02/2025',
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut, #CheckOut-home" ).datepicker( "setDate", newDate );
				$( "#CheckOut, #CheckOut-home" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$("#CheckIn, #CheckIn-home").datepicker("setDate", "05/02/2025");
		$( "#CheckOut, #CheckOut-home" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			minDate: '05/03/2025',
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});
		$( "#CheckOut, #CheckOut-home" ).datepicker("setDate", "05/03/2025");

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		$('[data-fancybox="gallery"]').fancybox({
			protect: true,
			loop: false,
			margin: [40, 0],
			gutter: 12,
			keyboard: true, 
			arrows: true,
			infobar: false,
			toolbar: true,
			buttons: [
				"slideShow",
				'fullScreen',
				// 'thumbs',
				// 'share',
				// "download",
				// 'zoom',
			"close"
			],
			image: {
				preload: "auto"
			},

			afterLoad: function(instance, current) {
			    var pixelRatio = window.devicePixelRatio || 1;

			    if ( pixelRatio > 1.5 ) {
			    	current.width  = current.width  / pixelRatio;
			    	current.height = current.height / pixelRatio;
			    }
		  	}
		});

		let isGallPage = $("#gallery .section-logo__logo img").attr("src","/assets/svg/dark-logo-new.svg");


		/* animation hover buttons */
		// $.each( $( ".btn" ), function( index, value ){
		// 	var str =  $(value).html();
		// 	$(value).html('');
		// 	for( var i = 0 ; i <= str.length ; i++ ){
		// 		$(value).html($(value).html() + '<span class="hover">' + str.charAt(i) + '</span>');
		// 	    //console.log( str.charAt(i) )
		// 	}

		// });


	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	/* detect all & on the title and add change it by a class */
	if( location.pathname == '/rooms-suites' || location.pathname == '/rates-packages' || location.pathname == '/about-us'){		
		var replaced = $(".hero-title").html().replace('&amp;','<span class="amp">&amp;</span>'); 
		$("#area").html(replaced);
	}
	else if( location.pathname != '/' ){

	}

	// else if ( location.pathname == '/gallery' ){
	// 	change logo on thr gallery page 
	// 	isGallPage();
	// }
	


}());


var isInternalPages = document.querySelector('#default, #map, #map-category, #attractions, body.sitemap');
if(isInternalPages){ document.querySelector('.section-logo__logo img').src = '/assets/svg/logo-new.svg';}



function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				document.querySelector('.section-logo__logo img').src = '/assets/svg/logo-new.svg';
				//document.getElementById('booking-form-widget').classList.add('show-widget');
				document.querySelector('.second-header__request-proposal-btns a.book-now-header-js').classList.add('show-btn');
				$("#gallery .section-logo__logo img").attr("src","/assets/svg/dark-logo-new.svg");
				$("#home .section-logo__logo img").attr("src","/assets/svg/dark-logo-new.svg");
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				document.querySelector('.section-logo__logo img').src = '/assets/svg/logo-new.svg';
				//document.getElementById('booking-form-widget').classList.add('show-widget');
				document.querySelector('.second-header__request-proposal-btns a.book-now-header-js').classList.add('show-btn');
				$("#gallery .section-logo__logo img").attr("src","/assets/svg/dark-logo-new.svg");
				$("#home .section-logo__logo img").attr("src","/assets/svg/dark-logo-new.svg");
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
			//document.getElementById('booking-form-widget').classList.remove('show-widget');
			document.querySelector('.section-logo__logo img').src = '/assets/svg/logo-new.svg';
			document.querySelector('.second-header__request-proposal-btns a.book-now-header-js').classList.remove('show-btn');
			//isGallPage();
			if(isInternalPages){ document.querySelector('.section-logo__logo img').src = '/assets/svg/logo-new.svg';}
			$("#gallery .section-logo__logo img").attr("src","/assets/svg/dark-logo-new.svg");
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


/* Open and close booking */
document.querySelector('.book-now-header-js').addEventListener('click', function(){
	document.getElementById('booking-overlay').classList.add('active');
});
document.querySelector('#booking-overlay .lightbox__close').addEventListener('click', function(){
	document.getElementById('booking-overlay').classList.remove('active');
});

/* tabs faq */
$('.toggle').click(function(e) {
  	e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);

    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
    }

    var arrowAccordion = $this.parent();

	if (arrowAccordion.hasClass('showing-tab')) {
	    arrowAccordion.removeClass('showing-tab');

	} else {
	    arrowAccordion.addClass('showing-tab');
	    //arrowAccordion.addClass('showing-tab');
	}

});


